import { render, staticRenderFns } from "./textual-match-feature-container.component.vue?vue&type=template&id=ed1fb982&scoped=true"
import script from "./textual-match-feature-container.component.vue?vue&type=script&lang=ts"
export * from "./textual-match-feature-container.component.vue?vue&type=script&lang=ts"
import style0 from "./textual-match-feature-container.component.vue?vue&type=style&index=0&id=ed1fb982&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed1fb982",
  null
  
)

export default component.exports